<template>
    <div>
        <v-dialog v-model="dialog" :width="width?width:'55%'" max-width="890" style="z-index:1005;" lazy>
            <!-- <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn> -->
            <div v-if="hideButton!=true" slot="activator" class="round-btn" @click="addingNewRecord()"><i class="fas fa-plus" /></div>
            <form>
                <v-card>
                    <v-tabs v-if="formDetails.hasTab" v-model="tabCategory" color="#409EFF" dark slider-color="#F56C6C">
                        <v-tab v-for="(tabs, key) in formDetails.tabOptions" v-if="checkTabVisible(tabs)" :key="key" :disabled="checkTabsDisable(tabs.value)" :active="checkTabActive(tabs.value, key)">
                            {{ tabs.name }}
                        </v-tab>
                    </v-tabs>
                    <div v-if="formDetails.hideHeadLine!=true" class="form-header">
                        <div class="flexbox flex-space-btw flex-vertical-center white-bg">
                            <span class="headline">{{ formDetails.formAction }} {{ formDetails.title }}</span>
                            <div v-if="createMultiple==true&&formDetails.formAction=='Create'"><a href="#" class="tableLinkID"><span>Create Mutiple</span></a></div>
                        </div>
                    </div>
                    <v-container class="form-content" grid-list-md>
                        <v-card-text>
                            <v-layout wrap>
                                <v-flex 
                                    v-for="(formItem, indexF) in formDetails.formInfo"
                                    v-if="formItem.type != 'group-fields' && checkVisible(formItem)"
                                    v-show="formItem.hide!=true"
                                    :key="'form'+indexF"
                                    :class="formItem.layout"
                                >
                                    <!-- Normal Input -->
                                    <v-text-field
                                        v-if="formItem.type == 'text'"
                                        v-model="formItem.value"
                                        v-validate="formItem.validate"
                                        :label="checkPlaceholderWithRequire(formItem.placeholder, formItem.validate)"
                                        :type="formItem.type"
                                        :error-messages="errors.collect(formItem.label)"
                                        :data-vv-name="formItem.label"
                                        required
                                    />

                                    <!-- Number Input -->
                                    <v-text-field
                                        v-if="formItem.type == 'number'"
                                        v-model.number="formItem.value"
                                        v-validate="formItem.validate"
                                        :label="checkPlaceholderWithRequire(formItem.placeholder, formItem.validate)"
                                        :type="formItem.type"
                                        :error-messages="errors.collect(formItem.label)"
                                        :data-vv-name="formItem.label"
                                        required
                                    />

                                    <!-- Select Input -->
                                    <v-autocomplete
                                        v-if="formItem.type == 'select'"
                                        v-model="formItem.value"
                                        v-validate="formItem.validate"
                                        :items="formItem.options"
                                        item-text="name"
                                        item-value="id"
                                        :label="checkPlaceholderWithRequire(formItem.placeholder, formItem.validate)"
                                        :error-messages="errors.collect(formItem.label)"
                                        :data-vv-name="formItem.label"
                                        required
                                        @change="categoryInput(formItem)"
                                    />

                                    <v-switch
                                        v-if="formItem.type == 'checkbox'"
                                        v-model="formItem.value"
                                        :label="checkPlaceholderWithRequire(formItem.placeholder, formItem.validate)"
                                    />

                                    <!-- ComboBox Input -->
                                    <v-combobox
                                        v-if="formItem.type == 'combobox'"
                                        v-model="formItem.value" 
                                        :items="formItem.options" 
                                        :label="checkPlaceholderWithRequire(formItem.placeholder, formItem.validate)" 
                                        item-text="name" 
                                        item-value="id" 
                                        chips 
                                        clearable 
                                        multiple 
                                        :hide-details="true"
                                    >
                                        <template slot="selection" slot-scope="data">
                                            <v-chip 
                                                :selected="data.selected" 
                                                close 
                                                @input="remove(data.item, index)"
                                            >
                                                <strong>{{ data.item.name }}</strong>&nbsp;
                                            </v-chip>
                                        </template>
                                    </v-combobox>

                                    <!-- Calendar Input -->
                                    <v-menu v-if="formItem.type == 'calendar'"
                                            v-model="formItem.isCalendarDialog"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            v-model="formItem.value"
                                            v-validate="formItem.validate"
                                            :label="checkPlaceholderWithRequire(formItem.placeholder, formItem.validate)"

                                            readonly
                                            :error-messages="errors.collect(formItem.label)"
                                            :data-vv-name="formItem.label"
                                        />
                                        <v-date-picker v-model="formItem.value" @input="formItem.isCalendarDialog = false" />
                                    </v-menu>

                                    <a v-if="formItem.enableCreateNew" class="tableLinkID" @click="emitCreateNewForm(formItem.placeholder)" v-text="' Click here to create new '+formItem.placeholder" />
                                </v-flex>

                                <!-- Group Item -->
                                <v-flex 
                                    v-for="(innerForm, index) in formItem[formItem.groupName]"
                                    v-else
                                    :key="'groupform'+indexF+index"
                                    :class="innerForm.layout"
                                >
                                    <!-- Normal Input -->
                                    <v-text-field
                                        v-if="innerForm.type == 'text'"
                                        v-model="innerForm.value"
                                        v-validate="innerForm.validate"
                                        :label="innerForm.placeholder"

                                        :type="innerForm.type"
                                        :error-messages="errors.collect(innerForm.label)"
                                        :data-vv-name="innerForm.label"
                                        required
                                    />

                                    <v-combobox
                                        v-if="innerForm.type == 'combobox'"
                                        v-model="innerForm.value"
                                        v-validate="innerForm.validate"
                                        :items="innerForm.options"
                                        item-text="name"
                                        item-value="name"
                                        :label="innerForm.placeholder"

                                        :return-object="false"
                                        :error-messages="errors.collect(innerForm.label)"
                                        :data-vv-name="innerForm.label"
                                        required
                                    />
                                </v-flex>
                            </v-layout>
                            <small>*indicates required field</small>
                        </v-card-text>
                    </v-container>

                    <v-card-actions>
                        <div class="actionDiv">
                            <v-btn color="#314c60" flat @click="dialog = false">Close</v-btn>
                            <v-btn color="primary" type="submit" @click.prevent="formSubmit()">Save</v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </form>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "FormDialog",

    props: ["formDetails","createMultiple", "isEditLoopingForm", "getID", "hideButton", "isDialog","width"],
    data () {
        return {
            parametersChips: [],
            dialog: false,
            category: null,
            myObj: {},
            tabCategory: null,
            active: null,
            text: 'Lorem ipsum dolor'
        };
    },
    watch: {
        dialog() {
            if (this.dialog == false) {
                this.$emit("update:isDialog", false);
                this.$emit("update:isEditLoopingForm", false);
                this.resetForm();
            } else {
                this.getFormOptions();
            }
        },
        isEditLoopingForm() {
            if (this.isEditLoopingForm == true) {
                this.dialog = true;
                this.getFormDetailsInfo();
            }
        },
        isDialog() {
            if (this.isDialog == true) {
                this.dialog = true;
                this.$store.state.isDialog = false;

                this.$emit("update:isEditLoopingForm", false);
                this.formDetails.formAction = "Create";
                this.formDetails.submitHttp = "POST";
            }
        },
        tabCategory() {
            this.setTabParameter(this.tabCategory);
        }
    },
    methods: {
        emitCreateNewForm(label) {
            this.$emit("create" + label);
            // this.dialog = false;
        },
        formSubmit() {
            this.$nextTick(() => {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.formDetails.formInfo.map(obj => { 
                            this.myObj[obj.label] = obj.value;

                            if (obj.type == "group-fields") {
                                this.myObj[obj.groupName] = {};
                                obj[obj.groupName].map(objGroup => {
                                    this.myObj[obj.groupName][objGroup.label] = objGroup.value;
                                });
                            }

                            // IF it is for update
                            if (this.getID) {
                                this.myObj.id = this.getID;
                            }
                        });

                        if (this.formDetails.tableID == "#RecordingTypeTable") {
                            if (this.myObj.observationCustomFields) {
                                this.myObj.observationCustomFields.map(obj => {
                                    obj["customFieldId"] = obj.id;
                                });
                            }
                        }

                        this.$nextTick(()  => {
                            axios({
                                method: this.formDetails.submitHttp,
                                url: this.formDetails.nameAPI + "/" + this.formDetails.formAction,
                                data: this.myObj,
                            }).then(response => {
                                this.dialog = false;
                                (this.formDetails.isArgrinomeTable) ? this.$emit("reloadRecord") : this.reloadTable(this.formDetails.tableID);
                                EventBus.$emit("snackBar", {
                                    text: this.formDetails.formAction + " " + this.formDetails.title + " Successfully",
                                    snackbarColor: "green darken-2"
                                });
                            });
                        });
                    }
                });
            });
        },
        resetForm() {
            this.formDetails.formInfo.forEach(function(formItem) {
                formItem.value = "";
                if (formItem.type == "group-fields") {
                    formItem[formItem.groupName].forEach(function(groupElement) {
                        groupElement.value = "";
                    });
                }
            });
            (this.formDetails.hasTab) ?  this.setTabParameter(0) : this.category = null;
        },
        setTabParameter(position) {
            var objIndex = this.formDetails.formInfo.findIndex((input => input.linkWithTab));
            if (this.formDetails.formInfo[objIndex]) this.formDetails.formInfo[objIndex].value = this.formDetails.tabOptions[position].value;
            this.category = this.formDetails.tabOptions[position].value;
        },
        checkPlaceholderWithRequire(placeholder, validate) {
            if (validate.includes("required")) {
                return placeholder + "*";
            }
            else return placeholder;
        },
        remove (item, index) {
            var array = this.formDetails.formInfo[index].value;
            array.splice(array.indexOf(item), 1);
            array = [...array];
        },
        addingNewRecord() {
            this.isEditLoopingForm = false;
            this.formDetails.formAction = "Create";
            this.formDetails.submitHttp = "POST";
        },
        checkVisible(item) {
            var cond1 = (item.displayOn) ? (item.displayOn == this.formDetails.formAction) ? true : false : true;
            var cond2 = (item.category) ? (item.category.includes(this.category)) ? true : false : true;

            return cond1 && cond2;
        },
        checkTabsDisable(value) {
            return (this.formDetails.formAction == "Update" && value != this.category) ? true : false;
        },
        checkTabVisible(tab) {
            return (tab.displayOn && this.formDetails.formAction != tab.displayOn) ? false : true;
        },
        checkTabActive(value, key) {
            if (value == this.category) this.tabCategory = key;
        },
        getFormDetailsInfo() {
            axios({
                method: "GET",
                url: this.formDetails.nameAPI + "/Get",
                params: {
                    Id: this.getID
                },
                cache: {
                    ignoreCache: true,
                },
            }).then((response) => {
                this.category = (this.formDetails.hasOwnProperty("categoryIdentifier")) ? response.data.result[this.formDetails.categoryIdentifier] : null;
                this.formDetails.formInfo.map(obj => {
                    for (var key in response.data.result) {
                        if (obj.label == key) {
                            obj.value = response.data.result[key];
                            if (obj.type == "calendar") {
                                if (response.data.result[key])
                                    obj.value = moment(response.data.result[key]).local().format("YYYY-MM-DD");
                            }
                        }
                    }

                    // FOR EDIT PROGENY PATERNAL
                    if (obj.groupName == "paternalPalmData") {
                        obj.paternalPalmData.map(item => {
                            if (item.label == "trialNumber") {
                                item.value = (((response.data.result || {}).paternalPalm || {}).trial || {}).trialNumber || null;
                            }
                            if (item.label == "progenyCode") {
                                item.value = (((response.data.result || {}).paternalPalm || {}).progeny || {}).code || null;
                            }
                            if (item.label == "palmNo") {
                                item.value = ((response.data.result || {}).paternalPalm || {}).trialPalmNumber || null;
                            }
                        });
                    }
                    // FOR EDIT PROGENY MATERNAL
                    if (obj.groupName == "maternalPalmData") {
                        obj.maternalPalmData.map(item => {
                            if (item.label == "trialNumber") {
                                item.value = (((response.data.result || {}).maternalPalm || {}).trial || {}).trialNumber || null;
                            }
                            if (item.label == "progenyCode") {
                                item.value = (((response.data.result || {}).maternalPalm || {}).progeny || {}).code || null;
                            }
                            if (item.label == "palmNo") {
                                item.value = ((response.data.result || {}).maternalPalm || {}).trialPalmNumber || null;
                            }
                        });
                    }
                });
            });
        },
        getFormOptions() {
            this.$emit("handleGetOptions");
        },
        categoryInput(item) {
            if (!item.isCategoryInput) return;
            this.category = item.value;
        }
    }
};
</script>

<style lang="css" scoped>
.form-header{
  padding: 2.5rem 3rem 0 3rem;
}
.form-content{
  padding: 0;
}
.actionDiv{
  padding: 1rem 2.5rem;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.v-tabs__item{
    padding: 6px 12px;
    padding-top: 6px;
    padding-right: 12px;
    padding-bottom: 6px;
    padding-left: 12px;
}
</style>


// WEBPACK FOOTER //
// src/smallComponents/LoopingFormDialog.vue